import React from 'react';

import { VerticalDivider } from '@europrocurement/flexy-components';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { faEllipsis, faFolderPlus } from '@fortawesome/sharp-regular-svg-icons';
import { PrescripteurApi, useSociete } from '@europrocurement/l2d-domain';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import { parcoursFormalitePathResolver } from '@europrocurement/l2d-modules';
import { usePrescriberFormaliste } from '../../../hooks';

export type PrescriberActionMenuProps = {
    prescriber: PrescripteurApi;
    fetchPrescriber: () => void;
};

export const PrescriberActionMenu: React.FunctionComponent<PrescriberActionMenuProps> = function (
    props,
) {
    const { prescriber, fetchPrescriber } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { openFormalisteModal } = usePrescriberFormaliste();

    const handleClickContextualMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenFormalisteModal = () => {
        openFormalisteModal(prescriber, fetchPrescriber);
    };

    const xIdSociete = useSociete();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <VerticalDivider sx={{ margin: '0px 10px' }} />

            <Button
                id="toolbar-contextual-menu-btn"
                aria-controls={open ? 'toolbar-contextual-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClickContextualMenu}
                sx={{ color: 'text.gris70' }}
            >
                <Box>
                    <FaOptionIcon
                        icon={faEllipsis}
                        size="lg"
                    />
                </Box>
            </Button>
            <Menu
                id="toolbar-contextual-menu"
                aria-labelledby="toolbar-contextual-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ sx: { py: 0 } }}
            >
                <MenuItem
                    onClick={() => {
                        if (xIdSociete !== 12) {
                            enqueueSnackbar(
                                'Impossible de saisir un dossier de formalite hors de Legal2Digital',
                            );
                            handleClose();
                            return;
                        }
                        navigate(parcoursFormalitePathResolver('stepContact'));
                    }}
                    sx={{ gap: '4px' }}
                >
                    <FaOptionIcon
                        icon={['fasl', faFolderPlus.iconName]}
                        color="text.gris70"
                    />
                    <Typography sx={{ color: 'text.primary' }}>
                        Nouveau dossier de formalités
                    </Typography>
                </MenuItem>
                <MenuItem
                    onClick={handleOpenFormalisteModal}
                    sx={{ gap: '4px' }}
                >
                    <FaOptionIcon
                        icon={['fasl', 'user-edit']}
                        color="text.gris70"
                    />
                    <Typography sx={{ color: 'text.primary' }}>
                        Modifier le formaliste assigné
                    </Typography>
                </MenuItem>
            </Menu>
        </Box>
    );
};
